import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';
import { Badge } from 'react-bootstrap';

import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';
import SocioDeNegocioStatus from '../enum/SocioDeNegocioStatus';

class SociosDeNegocioList extends Component {

  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selectedRowKeys: []
    }
  }

  get columns() {
    return [
      {
        key: 'razon_social',
        title: 'Socio',
        dataIndex: 'razon_social',
      },
      {
        key: 'email',
        title: 'Email',
        dataIndex: 'email',
      },
      {
        key: 'created_at',
        title: 'Alta',
        dataIndex: 'created_at',
      },
      {
        key: 'aceptado_at',
        title: 'Confirmación',
        dataIndex: 'aceptado_at',
      },
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        render: renderStatus
      },
    ];
  }

  async componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      this.paginate({
        page: 1,
        from,
        to
      });
    }
  }

  paginate(params) {
    this.props.paginate(params);
  }

  handleOnPageChange = (page) => {
    this.paginate(page);
  }

  handleRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys: selectedRowKeys
    }, () => {
      const { onRowSelectionChange } = this.props;

      onRowSelectionChange && onRowSelectionChange({selectedRowKeys, selectedRows});
    });
  }

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: record => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    }
  }

  getPaginationConfig() {
    const { pagination } = this.props;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange
    }
  }

  render() {
    const { columns, selectedRowKeys } = this.state;
    const { data, busy } = this.props;
    const { onRowClick } = this.props;

    return (
      <Table
        loading={ busy }
        columns={ columns }
        rowKey={ 'id' }
        data={ data }
        pagination={ this.getPaginationConfig() }
        rowSelection={ {
          selectedRowKeys: selectedRowKeys,
            ...this.getRowSelectionConfig()
          }
        }
        onRowClick={ onRowClick }
      >
      </Table>
    )
  }
}

const renderStatus = (item) => {
  let variant = 'warning';

  const status = SocioDeNegocioStatus.search(item.status);

  if (status.isActive()) {
    variant = 'success'
  } else if (status.isInactive()) {
    variant = 'danger';
  }

  return <Badge variant={ variant }>{ status.getName() }</Badge>
}

const mapState = (state) => {
  return state.modulo.socios.list;
}

const mapActions = (actions) => {
  return actions.modulo.socios.list;
}

export default connect(useStore, mapState, mapActions)(SociosDeNegocioList);